import { IEventFilter } from "@formant/core/model/IEventFilter";
import { IEventSort } from "@formant/core/model/IEventSort";

export interface IEventListState {
    filter: IEventFilter;
    page: number;
    sort: IEventSort;
}

export const emptyEventListState: IEventListState = {
    filter: {
        keyword: "",
        disableNullMatches: true,
    },
    page: 0,
    sort: { column: "time", order: "desc" },
};
